<script setup lang="ts">
interface TocSection {
  key: string;
  label: string;
}

defineProps<{
  sections: TocSection[];
}>();

const emit = defineEmits<{
  jump: [key: string];
}>();
</script>

<template>
  <nav class="toc__row" aria-label="Sections">
    <button
      v-for="section in sections"
      :key="section.key"
      type="button"
      class="toc__pill"
      @click="emit('jump', section.key)"
    >
      {{ section.label }}
    </button>
  </nav>
</template>

<style scoped>
.toc__row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 0;
}

.toc__pill {
  display: inline-flex;
  align-items: center;
  height: 1.75rem;
  padding: 0 0.75rem;
  border-radius: 999px;
  background: var(--nxt-surface-mid);
  color: var(--nxt-on-surface-muted);
  border: 1px solid var(--nxt-outline-variant);
  font-size: 0.75rem;
  font-weight: 700;
  cursor: pointer;
  transition:
    background 0.15s ease,
    color 0.15s ease,
    border-color 0.15s ease;
}
.toc__pill:hover {
  color: var(--nxt-primary);
  border-color: var(--nxt-primary);
}

[data-theme='dark'] .toc__pill:hover {
  color: #ffd60a;
  border-color: #ffd60a;
}
</style>
